// extracted by mini-css-extract-plugin
export default {"formGroup":"LockedFormGroup_formGroup__WCqD5"};